import { useContext, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { AccessRightContext } from "../../user/AccessRightProvider";
import { OrderType } from "../orderAPI";
import {
  fetchOrderRowsByBundleId,
  selectOrderRowById,
} from "../orderRowsDetailedSlice";
import { emptyOrderEdit } from "../orderTypes";
import { EditLongOrder } from "./long/EditLongOrder";
import { EditShortOrder } from "./short/EditShortOrder";

export const EditOrderPage = () => {
  const dispatch = useAppDispatch();
  const { bundleId } = useParams();

  const initialOrderRowBundle = useAppSelector((state) =>
    selectOrderRowById(state, bundleId!!),
  );

  const { canReadOrder } = useContext(AccessRightContext);

  const navigate = useNavigate();

  useEffect(() => {
    if (!initialOrderRowBundle) return;

    if (
      initialOrderRowBundle.eezyCompanyId &&
      !canReadOrder(initialOrderRowBundle.eezyCompanyId)
    ) {
      navigate("/home/orders");
    }
  }, [canReadOrder, navigate, initialOrderRowBundle]);

  useEffect(() => {
    if (!canReadOrder) return;

    dispatch(fetchOrderRowsByBundleId({ id: bundleId!! }));
  }, [dispatch, bundleId, canReadOrder]);

  return !initialOrderRowBundle ? null : initialOrderRowBundle?.type ===
    OrderType.Short ? (
    <EditShortOrder order={initialOrderRowBundle || emptyOrderEdit} />
  ) : (
    <EditLongOrder order={initialOrderRowBundle || emptyOrderEdit} />
  );
};
